// 完全に滑らかなカスタムアコーディオン
class SmoothAccordion {
  constructor(element) {
    this.accordion = element;
    this.summary = element.querySelector('summary');
    this.content = element.querySelector('.accordion__content');
    this.isAnimating = false;
    
    if (!this.summary || !this.content) return;
    
    this.init();
  }
  
  init() {
    // detailsのデフォルト動作を完全に無効化
    this.accordion.removeAttribute('open');
    
    // 初期スタイル設定
    this.content.style.height = '0px';
    this.content.style.overflow = 'hidden';
    this.content.style.opacity = '0';
    this.content.style.transform = 'translateY(20px)';
    
    // クリックイベント
    this.summary.addEventListener('click', (e) => {
      e.preventDefault();
      if (!this.isAnimating) {
        this.toggle();
      }
    });
  }
  
  toggle() {
    const isOpen = this.accordion.classList.contains('is-open');
    
    if (isOpen) {
      this.close();
    } else {
      this.open();
    }
  }
  
  open() {
    this.isAnimating = true;
    this.accordion.classList.add('is-open');
    this.accordion.setAttribute('open', '');
    
    // 実際の高さを正確に測定
    this.content.style.position = 'absolute';
    this.content.style.visibility = 'hidden';
    this.content.style.height = 'auto';
    this.content.style.opacity = '1';
    this.content.style.transform = 'translateY(0)';
    const height = this.content.offsetHeight;
    
    // 元に戻す
    this.content.style.position = '';
    this.content.style.visibility = '';
    this.content.style.height = '0px';
    this.content.style.opacity = '0';
    this.content.style.transform = 'translateY(20px)';
    
    // 強制的に再描画
    this.content.offsetHeight;
    
    // アニメーション開始
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        this.content.style.transition = 'height 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94), opacity 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94), transform 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94)';
        this.content.style.height = height + 'px';
        this.content.style.opacity = '1';
        this.content.style.transform = 'translateY(0)';
      });
    });
    
    // アニメーション完了後
    setTimeout(() => {
      this.content.style.height = 'auto';
      this.content.style.transition = '';
      this.isAnimating = false;
    }, 500);
  }
  
    close() {
    this.isAnimating = true;
    
    // 現在の実際の高さを取得
    const currentHeight = this.content.scrollHeight;
    
    // まず高さを固定（transitionなし）
    this.content.style.transition = 'none';
    this.content.style.height = currentHeight + 'px';
    this.content.style.overflow = 'hidden';
    this.content.style.minHeight = '0';
    
    // 強制再描画
    this.content.getBoundingClientRect();
    
    // わずかに遅延させてからアニメーション開始
    setTimeout(() => {
      this.content.style.transition = 'height 0.6s cubic-bezier(0.25, 0.46, 0.45, 0.94), opacity 0.5s 0.1s ease-out, transform 0.6s cubic-bezier(0.25, 0.46, 0.45, 0.94)';
      this.content.style.height = '0px';
      this.content.style.opacity = '0';
      this.content.style.transform = 'translateY(-5px)';
      this.content.style.paddingTop = '0px';
      this.content.style.paddingBottom = '0px';
      this.content.style.marginTop = '0px';
      this.content.style.marginBottom = '0px';
    }, 10);
    
    // アニメーション完了後
    setTimeout(() => {
      this.accordion.classList.remove('is-open');
      this.accordion.removeAttribute('open');
      this.content.style.transition = '';
      this.content.style.paddingTop = '';
      this.content.style.paddingBottom = '';
      this.content.style.marginTop = '';
      this.content.style.marginBottom = '';
      this.isAnimating = false;
    }, 610);
  }



}

// 初期化
document.addEventListener('DOMContentLoaded', function() {
  const accordions = document.querySelectorAll('details');
  accordions.forEach(accordion => new SmoothAccordion(accordion));
});
